(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cutxi-blog"] && !Shopify.designMode) return;
  try {
    
function initCutxiBlog(){document.querySelectorAll('[data-cx-blog]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const body=root.querySelector('[data-cx-body]'),toc=root.querySelector('[data-cx-toc]');if(body&&toc){const title=root.querySelector('h1').textContent.replace(/\s+/g,' ').trim();body.querySelectorAll('h1,h2').forEach(h=>{if(h.textContent.replace(/\s+/g,' ').trim()===title){h.remove();return}if(h.tagName==='H1'){const h2=document.createElement('h2');h2.innerHTML=h.innerHTML;if(h.id)h2.id=h.id;h.replaceWith(h2)}});const headings=[...body.querySelectorAll('h2')];if(headings.length){toc.hidden=false;headings.forEach((h,i)=>{if(!h.id){let id='cx-seccao-'+(i+1);while(document.getElementById(id))id+='-a';h.id=id}const li=document.createElement('li'),a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.append(a);const expand=headings.length>8&&i>=5;toc.querySelectorAll('ol')[expand?1:0].append(li)});if(headings.length>8){toc.querySelector('details').hidden=false;toc.querySelector('summary').textContent='Ver mais tópicos ('+(headings.length-5)+')'}}}const grid=root.querySelector('[data-cx-more-grid]'),button=root.querySelector('[data-cx-more]');if(grid&&button){let n=9;const cards=[...grid.children];const show=()=>{cards.forEach((c,i)=>c.hidden=i>=n);button.hidden=n>=cards.length};button.addEventListener('click',()=>{n+=9;show()});show()}})}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initCutxiBlog)}else{initCutxiBlog()}document.addEventListener('shopify:section:load',initCutxiBlog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-conjuntos"]) return;
  try {
    
if (!customElements.get('cutxi-conjuntos')) {
  customElements.define('cutxi-conjuntos', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = Array.from(this.querySelectorAll('.cs__card'));
      this.grid = this.querySelector('.cs__grid');
      this.category = 'all';
      this.sort = this.querySelector('[data-sort]');
      this.available = this.querySelector('[data-available]');
      this.querySelector('.cs__controls').hidden = false;
      this.querySelectorAll('[data-filter]').forEach(button => {
        button.addEventListener('click', () => {
          this.category = button.dataset.filter;
          this.update();
        });
      });
      this.sort.addEventListener('change', () => this.update());
      this.available.addEventListener('change', () => this.update());
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.category = 'all';
        this.available.checked = false;
        this.update();
        this.querySelector('[data-filter="all"]').focus();
      });
      this.update();
    }
    update() {
      let visible = 0;
      const cards = [...this.cards].sort((a,b) => {
        if (this.sort.value === 'low') return Number(a.dataset.price) - Number(b.dataset.price);
        if (this.sort.value === 'high') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.index) - Number(b.dataset.index);
      });
      cards.forEach(card => {
        card.hidden = !(this.category === 'all' || card.dataset.groups.split(' ').includes(this.category)) || (this.available.checked && card.dataset.instock !== 'true');
        if (!card.hidden) visible++;
        this.grid.appendChild(card);
      });
      this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.category)));
      this.querySelector('[data-count]').textContent = visible;
      const label = this.querySelector('[data-count-label]');
      label.textContent = visible === 1 ? label.dataset.one : label.dataset.many;
      this.querySelector('.cs__empty').hidden = visible > 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-escola"]) return;
  try {
    
if(!customElements.get('cutxi-escola'))customElements.define('cutxi-escola',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('.sc__item')];this.filter='all';this.sort=this.querySelector('[data-sort]');this.stock=this.querySelector('input[data-stock]');this.querySelector('[data-controls]').hidden=false;this.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{this.filter=b.dataset.filter;this.update()}));this.querySelector('[data-sesta]').addEventListener('click',()=>{this.filter='sesta';this.update()});this.sort.addEventListener('change',()=>this.update());this.stock.addEventListener('change',()=>this.update());this.querySelector('[data-reset]').addEventListener('click',()=>{this.filter='all';this.stock.checked=false;this.update();this.querySelector('[data-filter]').focus()});this.update()}
update(){let count=0;const grid=this.querySelector('.sc__grid');[...this.cards].sort((a,b)=>this.sort.value==='low'?+a.dataset.price-+b.dataset.price:this.sort.value==='high'?+b.dataset.price-+a.dataset.price:+a.dataset.order-+b.dataset.order).forEach(c=>{c.hidden=(this.filter!=='all'&&c.dataset.group!==this.filter)||(this.stock.checked&&c.dataset.stock!=='true');if(!c.hidden)count++;grid.appendChild(c)});this.querySelector('[data-count]').textContent=count;this.querySelector('[data-count-label]').textContent=count===1?'artigo':'artigos';this.querySelector('.sc__empty').hidden=count>0;this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===this.filter)))}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-gift-finder"]) return;
  try {
    
if(!customElements.get('cutxi-gift-finder')){
customElements.define('cutxi-gift-finder',class extends HTMLElement{
connectedCallback(){if(this.initialized)return;this.initialized=true;this.labels={};this.querySelector('[data-labels]').content.querySelectorAll('[data-key]').forEach(e=>this.labels[e.dataset.key]=e.textContent);this.answers=[];this.step=0;this.cards=[...this.querySelectorAll('[data-product]')];this.intro=this.querySelector('[data-intro]');this.panel=this.querySelector('[data-panel]');this.result=this.querySelector('[data-result]');this.question=this.querySelector('[data-question]');this.querySelector('[data-start]').hidden=false;this.querySelector('[data-start]').addEventListener('click',()=>this.start());this.querySelector('[data-restart]').addEventListener('click',()=>this.start());this.querySelector('[data-back]').addEventListener('click',()=>{if(this.step===0){this.panel.hidden=true;this.intro.hidden=false;this.querySelector('[data-start]').focus();return;}this.step--;this.answers=this.answers.slice(0,this.step);this.renderStep();});}
start(){this.answers=[];this.step=0;this.intro.hidden=true;this.result.hidden=true;this.panel.hidden=false;this.renderStep();}
renderStep(){this.panel.hidden=false;this.result.hidden=true;this.question.textContent=this.labels['quiz_q'+(this.step+1)];this.querySelector('[data-step]').textContent=this.step+1;this.querySelector('[data-budget-hint]').hidden=this.step!==2;let options;
if(this.step===0)options=['mae','pai','bebe','padrinhos','casal','amigos','professores'];
if(this.step===1){const occasions={mae:['aniversario','agradecer','surpresa','natal'],pai:['aniversario','agradecer','surpresa','natal'],bebe:['nascimento','aniversario','batizado','comunhao','escola'],padrinhos:['convidar','agradecer','aniversario','natal'],casal:['aniversario','surpresa','casamento','bodas','natal'],amigos:['aniversario','agradecer','surpresa','natal'],professores:['agradecer','aniversario','natal']};options=occasions[this.answers[0]];}
if(this.step===2)options=['1500','3000','5000','any'];const choices=this.querySelector('[data-choices]');choices.replaceChildren();options.forEach(value=>{const button=document.createElement('button');button.type='button';button.textContent=this.step===2?(value==='any'?this.labels.quiz_any_budget:this.labels.quiz_to+' '+this.formatMoney(Number(value))):this.labels[value];button.addEventListener('click',()=>{this.answers[this.step]=value;this.step++;if(this.step===3)this.showResult();else this.renderStep();});choices.appendChild(button);});this.question.focus({preventScroll:true});this.scrollIntoView({block:'start',behavior:'auto'});}
formatMoney(value){return new Intl.NumberFormat(document.documentElement.lang||'pt-PT',{style:'currency',currency:this.dataset.currency||'EUR',maximumFractionDigits:0}).format(value/100);}
showResult(){this.panel.hidden=true;this.result.hidden=false;const[recipient,occasion,budget]=this.answers;const cap=budget==='any'?Infinity:Number(budget);let shown=0;this.cards.forEach(card=>{const matches=card.dataset.recipients.split(',').includes(recipient)&&card.dataset.occasions.split(',').includes(occasion)&&Number(card.dataset.price)<=cap;card.hidden=!(matches&&shown<3);if(!card.hidden)shown++;});this.querySelector('[data-summary]').textContent=[this.labels[recipient],this.labels[occasion],budget==='any'?this.labels.quiz_any_budget:this.labels.quiz_to+' '+this.formatMoney(cap)].join(' · ');this.querySelector('[data-count]').textContent=shown===0?this.labels.quiz_zero:shown+' '+(shown===1?this.labels.quiz_one:this.labels.quiz_matched);this.querySelector('[data-empty]').hidden=shown>0;this.querySelector('[data-price-note]').hidden=shown===0;this.querySelector('.cxgf__delivery').open=false;this.querySelector('[data-result-heading]').focus({preventScroll:true});this.scrollIntoView({block:'start',behavior:'auto'});}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-recem-pais"]) return;
  try {
    
if(!customElements.get('cutxi-recem-pais'))customElements.define('cutxi-recem-pais',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('.cxparents__item')];this.filter='all';this.sort=this.querySelector('[data-sort]');this.stock=this.querySelector('input[data-stock]');this.querySelector('[data-controls]').hidden=false;this.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{this.filter=b.dataset.filter;this.update()}));this.sort.addEventListener('change',()=>this.update());this.stock.addEventListener('change',()=>this.update());this.querySelector('[data-reset]').addEventListener('click',()=>{this.filter='all';this.stock.checked=false;this.update();this.querySelector('[data-filter]').focus()});this.update()}
update(){let count=0;const grid=this.querySelector('.cxparents__grid');[...this.cards].sort((a,b)=>this.sort.value==='low'?+a.dataset.price-+b.dataset.price:this.sort.value==='high'?+b.dataset.price-+a.dataset.price:+a.dataset.order-+b.dataset.order).forEach(c=>{c.hidden=(this.filter!=='all'&&c.dataset.group!==this.filter)||(this.stock.checked&&c.dataset.stock!=='true');if(!c.hidden)count++;grid.appendChild(c)});this.querySelector('[data-count]').textContent=count;this.querySelector('[data-count-label]').textContent=count===1?'artigo':'artigos';this.querySelector('.cxparents__empty').hidden=count>0;this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===this.filter)))}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-soft-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!document.body.classList.contains('template-index')) return;
  const refineLaunchers = () => {
    document.querySelectorAll('[class*="kl-teaser-"] [role="button"]').forEach(button => {
      button.querySelectorAll('p span').forEach(label => {
        if (label.textContent.trim() === '5% OFF') label.textContent = '5% de boas-vindas';
      });
      if (button.textContent.includes('5% de boas-vindas') && button.getAttribute('aria-label') !== '5% de boas-vindas') button.setAttribute('aria-label', '5% de boas-vindas');
    });
    document.querySelectorAll('button[class*="_BubbleLauncher_"]').forEach(button => {
      if (!button.hasAttribute('aria-label')) button.setAttribute('aria-label', 'Pontos Cutxi');
    });
  };
  refineLaunchers();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refineLaunchers(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutxi-workshops"] && !Shopify.designMode) return;
  try {
    
function initCutxiCalendars(){document.querySelectorAll('[data-calendar-root]').forEach(root=>{const mount=root.querySelector('[data-calendar-months]');if(!mount||mount.childElementCount)return;const events=[...root.querySelectorAll('[data-event-date]')].filter(e=>/^\d{4}-\d{2}-\d{2}$/.test(e.dataset.eventDate));const months=[...new Set(events.map(e=>e.dataset.eventDate.slice(0,7)))].sort();months.forEach(key=>{const [year,month]=key.split('-').map(Number);const box=document.createElement('div');box.className='cxcal-month';const heading=document.createElement('h3');heading.textContent=new Date(year,month-1,1).toLocaleDateString('pt-PT',{month:'long',year:'numeric'});box.append(heading);const grid=document.createElement('div');grid.className='cxcal-grid';['Seg','Ter','Qua','Qui','Sex','Sáb','Dom'].forEach(day=>{const el=document.createElement('span');el.className='cxcal-weekday';el.textContent=day;grid.append(el)});const offset=(new Date(year,month-1,1).getDay()+6)%7;for(let i=0;i<offset;i++)grid.append(document.createElement('span'));for(let day=1;day<=new Date(year,month,0).getDate();day++){const date=key+'-'+String(day).padStart(2,'0');const found=events.find(e=>e.dataset.eventDate===date);const el=document.createElement(found?'a':'span');el.textContent=day;if(found){el.href='#'+found.id;el.setAttribute('aria-label',day+' — '+found.querySelector('h3').textContent);el.addEventListener('click',()=>{found.focus({preventScroll:true})})}grid.append(el)}box.append(grid);const legend=document.createElement('p');legend.className='cxcal-legend';legend.textContent='Dia com workshop · selecione para ver';box.append(legend);mount.append(box)})})}
initCutxiCalendars();document.addEventListener('shopify:section:load',initCutxiCalendars);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
